import { Component } from '@angular/core';
import { LocalizationService } from './services/localization.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private localizationService: LocalizationService) {
    this.localizationService.initLanguage();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/app.component.ts